import React from "react";
import {
  CartesianCoordinate,
  CylindricalCoordinate,
} from "../../../Model/Coordinate";
import TextBox from "../../Common/TextBox";
import "./DefaultVelocity.css";

interface DefaultVelocityProps<
  T extends CartesianCoordinate | CylindricalCoordinate
> {
  velocityOnAxes: T;
}
const DefaultVelocity = <T extends CartesianCoordinate | CylindricalCoordinate>({
  velocityOnAxes: speedOnAxes
 } : DefaultVelocityProps<T>) => {
  return (
    <div className="waypoint-offset default-velocity">
      <span
        style={{
          textAlign: "left",
          gridArea: "title",
          fontSize: 16,
        }}
      >
        Default Velocities
      </span>

      <div
        style={{
          gridArea: "table",
        }}
      >
        <table>
          <thead>
            <tr>
              <th>Axis</th>
              <th>Velocity</th>
            </tr>
          </thead>
          <tbody>
            {
              Object.keys(speedOnAxes).map((axis) => {
                let index = axis as keyof typeof speedOnAxes;
                let speedVal = speedOnAxes[index] as unknown as string;

                return (
                  <tr key={index+speedVal}>
                    <td>{axis.toUpperCase()}</td>
                    <td>
                      <TextBox
                        isInteger={false}
                        name={axis+"Velocity"}
                        value={speedVal}
                        readOnly={true}
                        disabled={true}
                      />
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DefaultVelocity;
